// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3eU9T","rootCenter":"LoadMoreObserver_rootCenter__2bNu-","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2fZXK"};